<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Interview_subjects/elements/Title.vue'

export default {
  name: 'InterviewSubjectForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
